// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"482":"2015ce64a71c534e4613","655":"04babf4e8ed863e9cbd2"}[chunkId] + ".js";
};